export default __webpack_public_path__ + "static/media/hht1_ep01_book_wp_02.c004d41f.jpg";